import { render, staticRenderFns } from "./LibraryItemSelector.vue?vue&type=template&id=3b7adf8f&scoped=true"
import script from "./LibraryItemSelector.vue?vue&type=script&lang=js"
export * from "./LibraryItemSelector.vue?vue&type=script&lang=js"
import style0 from "./LibraryItemSelector.vue?vue&type=style&index=0&id=3b7adf8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7adf8f",
  null
  
)

export default component.exports